angular
	.module 'App.Repository'
	.factory 'ShopRepository', ['BaseRepository', (BaseRepository) ->
		class ShopRepository extends BaseRepository
			@resource = '/shops'
			@isRestricted = true

			findByQuery: (query = null) ->
				if _.isEmpty(query)
					query = @createQuery()

				if !query.isSorted()
					query.sortBy 'name', 'ASC'

				super query

			searchShops: (name) ->
				query = @createQuery()
				query.criteria 'name', 'LIKE', name
				query.setPagination 0, @pageSize
				@findByQuery(query)

		return new ShopRepository
	]
